module.exports = __webpack_public_path__ + "media/images/pc/stores/funabashi/funabashi_concept_01-6432f4ce4899ce7ad788a063f71c347b.jpg";